import { FragmentType } from '@mp/graphql/generated';
import React from 'react';
import { JobDetailsFragment } from '../../jobDetailsComponents/graphql';
import { useShiftSwapData } from '../useShiftSwapData';
import { JobDetailsDeniedBanner } from './JobDetailsDeniedBanner';
import { JobDetailsAwaitReleaseBanner } from './JobDetailsAwaitReleaseBanner';

export const ShiftReleaseBanners = ({
  job,
}: {
  job?: FragmentType<typeof JobDetailsFragment> | null;
}) => {
  const {
    proHasSwapRequestPendingFacility,
    proDidSwapRequest,
    proAwaitingReleaseRequest,
    proAwaitingDropRequest,
    requestRejected,
    requestIsDrop,
    canShowShiftReleaseInfo,
    awaitingShiftRequestHours,
  } = useShiftSwapData({ job });

  if (!canShowShiftReleaseInfo) {
    return null;
  }

  if (requestRejected) {
    return <JobDetailsDeniedBanner isDropRequest={requestIsDrop} />;
  }

  const hours = Boolean(awaitingShiftRequestHours) ? String(awaitingShiftRequestHours) : '0';

  const isAwaiting =
    proHasSwapRequestPendingFacility ||
    proDidSwapRequest ||
    proAwaitingDropRequest ||
    proAwaitingReleaseRequest;

  if (isAwaiting) {
    return (
      <JobDetailsAwaitReleaseBanner
        hours={hours}
        proDidSwapRequest={proDidSwapRequest}
        proHasSwapRequestPendingFacility={proHasSwapRequestPendingFacility}
        proAwaitingDropRequest={proAwaitingDropRequest}
        proAwaitingReleaseRequest={proAwaitingReleaseRequest}
      />
    );
  }

  return null;
};
